
module.directive('basicForm', function() {
    return {
        restrict: 'E',
        templateUrl: 'util/forms/basicForm',
        transclude: true,
        scope: {
            saveButtonText: '@',
            deleteButtonText: '@',
            expose: '&',
        },
        controller: module.cC({

            inject: ['$scope', '$element', '$q', 'Notifications', '$attrs'],

            data: function() {
                return {
                    inlineForm: this.$element.inheritedData('$inlineFormController'),
                    errorMessage: "There was a problem saving this form.",
                    validationMessage: "Please correct issues and submit the form again.",
                    successMessage: "Data saved successfully.",
                    deleteMessage: "Data was deleted successfully.",
                    deleteErrorMessage: "Could not delete this data.",
                };
            },

            init: function() {
                this.closeOnSave = true;
                this._inlineRegister();

                if(this.$scope.expose) {
                    this.$.expose({form: this});
                }
                this.$.noButtons = angular.isDefined(this.$attrs.noButtons);
            },

            on: {'$destroy': function() {this._inlineDeregister(); }},

            methods: {
                save: angular.noop,
                cancel: angular.noop,
                delete: angular.noop,

                setDeleteFunctions: function(performDelete, allowDelete) {
                    allowDelete = allowDelete || function() {
                        return angular.isDefined(performDelete);
                    };

                    this.delete = angular.bind(this, performDelete || angular.noop, this.$);
                    this.allowDelete = angular.bind(this, allowDelete);
                    this.$.allowDelete = this.allowDelete;
                },

                allowDelete: function() {
                    return false;
                },

                getForm: function() {
                    return this.$.form;
                },

                setOpenData: function(data) {
                    this.openData = data;
                },

                doCancel: function() {
                    this._closeInlineForm();
                    this.cancel();
                },

                doDelete: function() {
                    if (!this.allowDelete()) {
                        this._closeInlineForm();
                    }
                    return this.$q.when(this.delete())
                        .then(this._deleteSuccess, this._deleteFailure);
                },

                doSave: function(additional) {
                    if (this.$.form.$invalid) {
                        this.Notifications.error(this.validationMessage);
                        return this.$q.reject();
                    }
                    if (this.$.form.$pending) return;

                    this._replaceUndefined(this.data);
                    return this.$q.when(this.save(this.data, additional));
                        // .then(this._saveSuccess, this._saveFailure);
                },

                isDirty: function() {
                    return this.$.form && this.$.form.$dirty;
                },

                saveSuccess: function(data) {
                    this.Notifications.success(this.successMessage);
                    if (this.closeOnSave) {
                        this._closeInlineForm();
                    }
                    return data;
                },

                saveFailure: function(rejection) {
                    this.Notifications.error(this.errorMessage);
                },

                _deleteFailure: function(rejection) {
                    this.Notifications.error(this.deleteErrorMessage);
                    this._closeInlineForm();
                },

                _deleteSuccess: function() {
                    this.Notifications.success(this.deleteMessage);
                    this._closeInlineForm();
                },

                _inlineRegister: function() {
                    if (this.inlineForm) {
                        this.inlineForm.addFormController(this);
                    }
                },

                _inlineDeregister: function() {
                    if (this.inlineForm) {
                        this.inlineForm.removeFormController(this);
                    }
                },

                _closeInlineForm: function() {
                    if (angular.isDefined(this.inlineForm)) {
                        this.inlineForm.close();
                    }
                },

                _replaceUndefined: function(data) {
                    for (var key in data) {
                        if (angular.isUndefined(data[key])) {
                            data[key] = null;
                        }
                    }
                },
            }
        }),
    };
});


module.factory('makeBasicForm', function() {
    return function(directive) {
        return {
            restrict: 'E',
            templateUrl: directive.templateUrl,
            scope: directive.scope,
            require: '^basicForm',
            link: function(scope, element, attrs, basicForm) {
                scope.basicForm = basicForm;
                scope.form = basicForm.getForm();
                scope.data = basicForm.data = directive.copyData ?
                                              directive.copyData(scope) :
                                              {};

                angular.extend(scope, (directive.data || {}));


                basicForm.save = function(data) {
                    return directive.save(scope, data);
                }

                function bindIfExists(fn) {
                    return fn && fn.bind(directive, scope);
                }

                if (directive.delete) {
                    basicForm.setDeleteFunctions(
                        bindIfExists(directive.delete),
                        bindIfExists(directive.canDelete)
                    );
                }

                if (directive.link) {
                    directive.link(scope, element, attrs, basicForm);
                }
            }
        }
    }
});

